const {
    find, isEmpty, map, remove,
} = require('lodash');

class DigitalPayDisablePaymentStateService {
    constructor() {
        this.disablePaymentStates = [];
    }

    /**
     * Initialise disable payment state service with clean state.
     */
    init() {
        // Reset disable payment states.
        this.disablePaymentStates = [];
    }

    /**
     * Adds a new disable payment state which implies payment is not ready to be made yet.
     * @param {String} state (must be unique)
     * @param {String} reason Reason for screen readers
     */
    addDisablePaymentState(state, reason = '') {
        if (find(this.disablePaymentStates, disableState => disableState.state === state)) {
            return;
        }
        this.disablePaymentStates.push({ state, reason });
    }

    /**
     * Lists why payment has been disabled.
     */
    getReasonsWhyDisabled() {
        return map(this.disablePaymentStates, disableState => disableState.reason).toString();
    }

    /**
     * Returns true there are disable payment states; otherwise false.
     */
    hasDisablePaymentStates() {
        return !isEmpty(this.disablePaymentStates);
    }

    /**
     * Removes the given disable payment state.
     * @param {String} state
     */
    removeDisablePaymentState(state) {
        remove(this.disablePaymentStates, disableState => disableState.state === state);
    }
}

module.exports = DigitalPayDisablePaymentStateService;



// WEBPACK FOOTER //
// ./src/digitalpay/services/digital-pay-disable-payment-state.service.js